import constants from "@/config/constants";
import { generateQueryString, generateProxyUsername } from "@/utils/template_utils";

const templates = {
    CURL: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            return `curl --request GET \\\n` +
                `--url 'https://${constants.API_SERVICE_HOST}${path}?${generateQueryString(request_generator, api_token)}'`;
        }
    },

    PYTHON: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            return `import http.client\n` +
                `\n` +
                `conn = http.client.HTTPSConnection("${constants.API_SERVICE_HOST}")\n` +
                `\n` +
                `conn.request("GET", "${path}?${generateQueryString(request_generator, api_token)}")\n` +
                `\n` +
                `res = conn.getresponse()\n` +
                `data = res.read()\n` +
                `\n` +
                `print(data.decode("utf-8"))`
        },
    },

    NODE_JS: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            return `var http = require("https");\n` +
                `\n` +
                `var options = {\n` +
                `   "method": "GET",\n` +
                `   "hostname": "${constants.API_SERVICE_HOST}",\n` +
                `   "port": null,\n` +
                `   "path": "${path}?${generateQueryString(request_generator, api_token)}",\n` +
                `   "headers": {\n` +
                `       "useQueryString": true\n` +
                `   }\n` +
                `};\n` +
                `\n` +
                `var req = http.request(options, function (res) {\n` +
                `   var chunks = [];\n` +
                `   res.on("data", function (chunk) {\n` +
                `       chunks.push(chunk);\n` +
                `   });\n` +
                `\n` +
                `   res.on("end", function () {\n` +
                `       var body = Buffer.concat(chunks);\n` +
                `       console.log(body.toString());\n` +
                `   });\n` +
                `});\n` +
                `\n` +
                `req.end();`
        },
    },
    PROXY: {
        get: (request_generator, api_token) => {
            const proxyUsername = generateProxyUsername(request_generator);
            return `{\n` +
               `    http: '${proxyUsername}:${api_token}@proxy.scrapingant.com:8080',\n` +
               `    https: '${proxyUsername}:${api_token}@proxy.scrapingant.com:443'\n` +
                `}`;
        }
    },
}

export default templates
